import React from 'react'

const Testimoni = () => {
  return (
    <div>Testimoni</div>
  )
}

export default Testimoni